import { EpimsBaseEntityDto } from './epim-base.dto';
export class QuantumDto extends EpimsBaseEntityDto {
  QuantumName: string;
  DistributorFactorValue: number;
  DistributorFactorName: string;
  SubscriptionUserId: string;
  Version: number;
}
